<template>
  <div class="commission-details" ref="container">
    <nav-bar fixed z-index="99" title="" left-text="返回" left-arrow @click-left="$router.go(-1)" />
    <div style="height: 46px"></div>
    <div class="promoterHeader bg-color-theme">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">提现记录</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="data">{{ item.time }}</div>
          <div class="listn" v-for="(val, indexn) in item.list" :key="indexn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.title }}</div>
                <div>{{ val.addTime }}</div>
              </div>

              <div style="flex: 1;">
                <div class="num" v-if="val.pm == 1">+{{ val.number }}</div>
                <div class="num font-color-theme" v-if="val.pm == 0">
                  -{{ val.number }}
                </div>
              </div>
              <div class="" style="font-size: 0.26rem;color: black"
                @click="$router.push({ path: '/order/list', query: { userCategory: 2, orderId: val.orderId } })">查看订单
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getCommissionInfo, getSpreadInfo } from "../../../api/user";
import Loading from "@components/Loading";
import { NavBar } from "vant";

export default {
  name: "CashRecord",
  components: {
    Loading,
    NavBar,
  },
  props: {},
  data: function () {
    return {
      info: [],
      commission: 0,
      where: {
        page: 1,
        limit: 3,
      },
      types: 4,
      loaded: false,
      loading: false,
    };
  },
  mounted: function () {
    // this.init();
  },
  watch: {
    $route: {
      handler: function (val) {
        // 判断是否是进入页面，是则初始化
        if (val.name === "CashRecord"){
          this.init()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      this.info = [];
      this.where.page = 1;
      this.loaded = false;
      this.loading = false;

      this.getCommission();
      this.getIndex();
      this.$scroll(this.$refs.container, () => {
        this.loading === false && this.getIndex();
      });
    },
    getIndex: function () {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getCommissionInfo(that.where, that.types).then(
        (res) => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        (error) => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getCommission: function () {
      let that = this;
      getSpreadInfo().then(
        (res) => {
          that.commission = res.data.extractCount; 
        },
        (error) => {
          this.$dialog.message(error.msg);
        }
      );
    },
  },
};
</script>
